import { Component, Input } from '@angular/core'
import times from 'lodash-es/times'

@Component({
  selector: 'pagination-links',
  template: `
    <nav>
      <ul class="pagination">
        <li class="page-item" *ngIf="currentPage > windowSize">
          <a class="page-link" [routerLink]="route" [queryParams]="queryParamsForPage(1)">First</a>
        </li>
        <li class="page-item" *ngIf="currentPage > windowSize">
          <a class="page-link" [routerLink]="route" [queryParams]="queryParamsForPage(currentPage-windowSize)">&laquo;</a>
        </li>
        <li class="page-item" *ngFor="let page of pagesArray" [class.active]="page === currentPage">
          <a class="page-link" [routerLink]="route" [queryParams]="queryParamsForPage(page)">{{ page }}</a>
        </li>
        <li class="page-item" *ngIf="pages >= currentPage + windowSize">
          <a class="page-link" [routerLink]="route" [queryParams]="queryParamsForPage(currentPage+windowSize)">&raquo;</a>
        </li>
        <li class="page-item" *ngIf="currentPage < pages - windowSize">
          <a class="page-link" [routerLink]="route" [queryParams]="queryParamsForPage(pages)">Last</a>
        </li>
      </ul>
    </nav>
  `,
})
export class PaginationLinks {
  @Input() route: any[] = ['/'];
  @Input() queryParams: object = {};
  @Input() pages: number = 1;
  @Input() currentPage: number = 1;
  @Input() name: string; // name the page param something other than 'page'
  @Input() small: boolean = false;
  pagesArray: number[] = [];
  windowSize: number = 7;

  ngOnChanges(changeRecord: any): void {
    this.pagesArray = this.createPagesArray()
  }

  createPagesArray(): number[] {
    const allPages = times<number>(this.pages, n => n + 1)
    return allPages.filter(p => {
      return (p < this.currentPage + this.windowSize && p > this.currentPage - this.windowSize)
    })
  }

  queryParamsForPage(page: number): object {
    return Object.assign({}, this.queryParams, {
      [ this.name || 'page' ]: page
    })
  }
}
